import React, { useState } from 'react';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import PatientHeader from '../../Layout/PatientHeader';
import DasboardCard from './DasboardCard';

const Dasboard = () => {
  const [height,setHeight] = useState(0);
  return (
    <div>
      <Header setHeight={setHeight} />
      <div className="profile_crumb" style={{height: height+10 +"px"}}></div>
      <section className="py-5">
        <PatientHeader title="My Appointments" />
        <div className="profile-page">
        <div className="container px-5">
        <div className="row">
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Pending" color="#ffc107" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Approved" color="#008000" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Cancelled" color="red" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Approved" color="#008000" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Cancelled" color="red" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Pending" color="#ffc107" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Pending" color="#ffc107" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Approved" color="#008000" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 my-3">
              <DasboardCard name="Dr. Name" specialization="Primary Care Doctor" time="5:00PM - 6:00PM" date="17 Nov 2020" action="Cancelled" color="red" />
            </div>
        </div>
        </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Dasboard;